import { IconSettings } from '@tabler/icons-react';
import { ButtonField } from '@wk/components-react16';

import type { OnboardingCheckpointListProps } from '@/features/onboarding/types/onboarding.types';

import OnboardingCheckpointStatusTags from './OnboardingCheckpointStatusTags';

const OnboardingCheckpointCards = <TCheckpoint,>({
  checkpoints,
  configureLabel = 'Configure',
  onConfigureCheckpoint,
}: OnboardingCheckpointListProps<TCheckpoint>) => (
  <div className="subject-onboarding-cards-container max-sm:h-[58vh] max-sm:min-h-[340px] max-sm:overflow-y-auto max-sm:pr-1">
    <div className="flex flex-col gap-3">
      {checkpoints.map((checkpoint) => (
        <article
          key={checkpoint.key}
          className="rounded-lg border bg-white p-3 shadow-sm"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <h2 className="break-words text-base font-semibold leading-5">
                {checkpoint.id}
              </h2>
              <p className="mt-1 text-xs text-gray-500">
                Version {checkpoint.versionLabel}
              </p>
            </div>
            <ButtonField mode="ghost" size="small">
              <button
                type="button"
                onClick={() =>
                  onConfigureCheckpoint(checkpoint.rawCheckpoint)
                }
              >
                <IconSettings size={14} />
                {configureLabel}
              </button>
            </ButtonField>
          </div>

          <div className="mt-3">
            <OnboardingCheckpointStatusTags
              exceptionApprovalStatus={
                checkpoint.exceptionApprovalStatus
              }
              isNew={checkpoint.isNew}
              isPreview={checkpoint.isPreview}
              requiresParameters={checkpoint.requiresParameters}
            />
          </div>

          <dl className="mt-3 grid grid-cols-1 gap-2 text-sm">
            <div>
              <dt className="text-[10px] uppercase tracking-wide text-gray-500">
                Description
              </dt>
              <dd className="break-words">
                {checkpoint.description || 'N/A'}
              </dd>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <dt className="text-[10px] uppercase tracking-wide text-gray-500">
                  Category
                </dt>
                <dd>{checkpoint.category || 'N/A'}</dd>
              </div>
              <div>
                <dt className="text-[10px] uppercase tracking-wide text-gray-500">
                  Accountable
                </dt>
                <dd>{checkpoint.accountable || 'N/A'}</dd>
              </div>
            </div>
          </dl>
        </article>
      ))}
    </div>
  </div>
);

export default OnboardingCheckpointCards;
